import React, { useState, useEffect } from "react";
import { BsArrowUpCircle } from "react-icons/bs";
import { ethers } from "ethers";
import axios from "axios";
import newContractAbi from "../Services/NewContractAbi.json";
import { EscrowContractAddress } from "../Services/EscrowContractAddress";
import EscrowContractAbi from "../Services/EscrowContractAbi.json";
import { EthContracatAddress } from "../Services/EthContractAddress";
import EthContractAbi from "../Services/EthContracatAbi.json"
import { useNetwork,useSigner,useAccount } from "wagmi";
import { Spinner } from "flowbite-react";
const { BigNumber } = require("ethers");

const TransactionCompleted = () => {
  let time;
  let l;
  let date;
  //------------------------USESTATES---------------------------------------------------//
  const [newAddress, setNewAddress] = useState();
  const [receiversAddress, setReceiverAddress] = useState();
  const [btcamount, setBtcAmount] = useState();
  const [hash, setHash] = useState();
  const [transtime, setTransTime] = useState();
  let [waiting, setWaiting] = useState(true);
  const [coin,setCoin] = useState();
  
  
  const { data: signer } = useSigner();
  const { chain } = useNetwork();
  //---------------------------USE=EFFECT=HOOK---------------------------------//
  useEffect(() => {
    if(signer)
    {
      getTransactionDetails();
    }

   
    console.log("useEffect", chain.id);
    console.log("Component mounted or updated");
  },[newAddress,chain]);

 

  const getTransactionDetails = async () => {
    console.log("iddddd",chain.id);
   
    if(chain.id === 11155111){
      //console.log("Sepolia Network")
      setCoin("ETH");
      const Contract = new ethers.Contract(
        EthContracatAddress,
        EthContractAbi,
        signer
      );
      const useraddress  =signer.getAddress();
      try {
        const reciverAddress = localStorage.getItem('receiverAddress');
        const amount = localStorage.getItem('BTCamount')
        const hash = localStorage.getItem("EthHash")
        // console.log("this is the hash",hash)
        const link = "https://sepolia.etherscan.io/tx/";
        const fullhash = link+hash;
        setHash(fullhash);
       
        // console.log("Full ddddd", fullhash)
        setBtcAmount(amount);
        setReceiverAddress(reciverAddress);
        await Contract?.getUsercontracts(useraddress).then(async (response) => {
          const length = response.length - 1;
          setNewAddress(response[length]);
  
          const newContract = new ethers.Contract(
            newAddress,
            newContractAbi,
            signer
          );
  
          let newTransaction = await newContract.smartContract();
          const bigNumber = BigNumber.from(newTransaction.unlockTime);
          const timeInSeconds = bigNumber.toString(); // time in seconds from the contract
           const data = {contAddress:newAddress, date:timeInSeconds*1000+60000}
           await axios.post(`${process.env.React_App_baseUrl}etherem/setSchedule`, data).then(async(res)=>{
            console.log("responsiveness",res)
            if(res.status===200)
            {
              try{
                date = new Date(); // create a new date object with the Unix epoch as the initial value
            date.setTime(timeInSeconds*1000);
            time = date.toString(); // readeable time format
            setTransTime(time); //updating time variable
            l = new Date();
            setWaiting(false)
              }catch(error){
                setWaiting(false)
              }
            }
            
           })
         
          // console.log(l);
        }).catch((error)=>{console.log(error);
          setWaiting(false)})
      } catch (error) {
        setWaiting(false)
        console.log(error);
      }
      
    }else{
      

      console.log( "Smart Chain Network")
      setCoin("BNB");
      const Contract = new ethers.Contract(
        EscrowContractAddress,
        EscrowContractAbi,
        signer
      );
      const useraddress = signer.getAddress();
      try {
        const reciverAddress = localStorage.getItem('receiverAddress');
        const amount = localStorage.getItem('BTCamount')
        const hash = localStorage.getItem("BEPhash")
        const link = "https://testnet.bscscan.com/tx/";
        const fullhash = link+hash;
        setHash(fullhash);
        setBtcAmount(amount);
        setReceiverAddress(reciverAddress);
        await Contract?.getUsercontracts(useraddress).then(async (response) => {
          const length = response.length - 1;
          setNewAddress(response[length]);
  
          const newContract = new ethers.Contract(
            newAddress,
            newContractAbi,
            signer
          );
  
          let newTransaction = await newContract.smartContract();
          const bigNumber = BigNumber.from(newTransaction.unlockTime);
          const timeInSeconds = bigNumber.toString(); // time in seconds from the contract
           const data = {contAddress:newAddress, date:timeInSeconds*1000+60000}
         
         await axios.post(`${process.env.React_App_baseUrl}bnb/setSchedule`, data).then(async(res)=>{
          if(res.status===200)
          {
            try{
              date = new Date(); // create a new date object with the Unix epoch as the initial value
              date.setTime(timeInSeconds*1000);
              time = date.toString(); // readeable time format
              setTransTime(time); //updating time variable
              l = new Date();
              setWaiting(false);
            }catch(error){
              
              setWaiting(false)
            }
          }
           
            })
         
        }).catch((error)=>{console.log(error)
          setWaiting(false)})
      } catch (error) {
        console.log(error);
        setWaiting(false)
      }
    }
  };

  return (
    <div className=" h-screen flex items-center justify-center ">
      {waiting ? (
        <Spinner />
      ) : (
        <div className="w-auto text-center tracking-widest p-4 pt-8  ml-2  bg-slate-50 shadow-lg h-fit  ">
          <h1 className=" text-3xl"> Sent {coin}</h1>
          <center className="mt-4">
            <BsArrowUpCircle color="orange" size={140} />
          </center>
          <h1 className="text-2xl mt-4 "> {btcamount} {coin}</h1>
        <p className="text-2xl mt-1">{btcamount}</p>
          <div className="md:flex justify-between mt-4 mb-2 overflow-y-auto ">
            <h1 className=" text-xl"> To</h1>
            <p className="md:text-xl text-xs tracking-normal"> {receiversAddress}</p>
          </div>
          <hr className="border-dashed w-full bg-slate-500"></hr>
          <div className="flex justify-between text-xl mt-2 mb-2 ">
            <h1> Free</h1>
            <p> {btcamount} {coin}</p>
          </div>
          <hr className="border-dashed w-full  bg-slate-500"></hr>
          <div className="flex justify-between gap-10 lg:gap-56 mt-2 mb-2">
            <h1> Date/Time</h1>
            <p> {transtime}</p>
          </div>
          <hr className="border-dashed w-full bg-slate-500"></hr>
          <div className="flex justify-between mt-2 mb-2 ">
            <h1> Transaction</h1>
            <a href={hash} target="_blank" rel="noopener noreferrer" className="text-blue-700 font-semibold">
              {" "}
              View Transactions
            </a>
          </div>
          <hr className="border-dashed w-full bg-slate-500"></hr>
          <div className="flex justify-between mt-2">
            <h1> Status</h1>
            <p
              className="bg-green-200 p-1 text-green-600"
              
            >
              {" "}
              COMPLETED{" "}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionCompleted;

// 58A1686102Fa$ba925C46Bc4
